import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { submit, getFormValues, getFormInitialValues } from 'redux-form'
import { useTranslation } from 'react-i18next'

import { getCurrentAppData } from '../utils/fractalApps'
import UserCard from '../components/card/UserCard'
import SecurityCard from '../components/card/SecurityCard'
import { Button } from '../components/shared/styles/Button.style'

import { logout as logoutAction } from '../store/auth/actions'

const compareValues = (current, initial) => {
  const properties = Object.keys(initial)
  return properties.some(prop => current[prop] !== initial[prop])
}

const ProfilePage = (props) => {
  const { formValues, formInitialValues, lang } = props
  const appData = getCurrentAppData()
  const { t: translation } = useTranslation()
  return (
    <div>
      <UserCard lang={lang} translation={translation} />

      <SecurityCard lang={lang} translation={translation} />
      <div style={{ display: 'flex', paddingLeft: '5%', width: '50%', justifyContent: 'space-around' }}>
        <Button onClick={() => props.submit('editForm')} > {translation('profilePage')['saveButton']} </Button>
        <Button onClick={
          () => {
            if (compareValues(formValues, formInitialValues)) {
              var r = confirm(translation('profilePage')['warning'])
              if (r === true && appData && appData.redirectUrl) {
                window.location.href = appData.redirectUrl
              } else {
                return null
              }
            } else if (appData && appData.redirectUrl) {
              window.location.href = appData.redirectUrl
            }
          }
        }> {translation('profilePage')['cancelButton']} </Button>
      </div>
    </div>
  )
}

ProfilePage.propTypes = {
  submit: PropTypes.func,
  formInitialValues: PropTypes.object,
  formValues: PropTypes.object,
  lang: PropTypes.string
}

const mapStateToProps = ({ auth, ...state }) => ({
  user: auth.user,
  formValues: getFormValues('editForm')(state),
  formInitialValues: getFormInitialValues('editForm')(state),
  lang: auth.lang
})

const mapDispatchToPros = dispatch =>
  bindActionCreators(
    {
      logout: logoutAction,
      submit: submit
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToPros)(ProfilePage)
